import { IcosTableHeader } from './header'
import { IcosTableColumn } from './column'
import { IcosTableBody } from './body'

export {
  IcosTableHeader,
  IcosTableColumn,
  IcosTableBody,
}

